import { createGStore } from "create-gstore";
import { useEffect, useRef, useState } from "react";

export const useDynamicTitle = createGStore(() => {
  const [dynamicTitle, setDynamicTitle] = useState<string | null>(null);

  return { dynamicTitle, setDynamicTitle };
});

/**
 * Hook to set dynamic title from page components
 * Automatically clears title on unmount
 */
export function useSetDynamicTitle(title: string | null | undefined) {
  const { setDynamicTitle } = useDynamicTitle();
  const prevTitleRef = useRef<string | null>(null);

  // Set synchronously on first render and when title changes
  const normalizedTitle = title ?? null;
  if (prevTitleRef.current !== normalizedTitle) {
    prevTitleRef.current = normalizedTitle;
    setDynamicTitle(normalizedTitle);
  }

  // Cleanup on unmount
  useEffect(() => {
    return () => setDynamicTitle(null);
  }, [setDynamicTitle]);
}
